import React from 'react';

function WalletRow(props) {
    if (!parseFloat(props.available) && !parseFloat(props.onOrder)) return <React.Fragment></React.Fragment>;

    return (
        <tr>
            <td data-label="COIN" className="text-gray-900">
                <img className="me-2" alt="" width={16} src={`/img/icons/black/${props.symbol.toLowerCase()}.svg`} />
                {props.symbol}
            </td>
            <td data-label="FREE" className="text-gray-900 num">
                {`${parseFloat(props.available).toFixed(8)}`.substring(0, 10)}
            </td>
            <td data-label="LOCKED" className="text-gray-900 num">
                {`${parseFloat(props.onOrder).toFixed(8)}`.substring(0, 10)}
            </td>
        </tr>
    )
}

export default WalletRow;